import styled from "styled-components"

const ReservationActions = styled.div``

export { ReservationActions }
